import React from 'react';
import * as BREAKPOINTS from '@zola/zola-ui/src/styles/emotion/mediaQuery';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { HighlightTitle } from '@zola/zola-ui/src/components/PreAuthV3';

import getSourceElements, { ImageType } from 'libs/client/Image/getSourceElements';

import {
  ButtonWrapper,
  ContentWrapper,
  HeroImage,
  HeroSection,
  MediaContainer,
} from './Hero.styles';

import Mobile from '../../../../public/static-preauth/images/ContactUs/hero/mobile.jpg';
import Mobile2x from '../../../../public/static-preauth/images/ContactUs/hero/mobile@2x.jpg';
import Tablet from '../../../../public/static-preauth/images/ContactUs/hero/tablet.jpg';
import Tablet2x from '../../../../public/static-preauth/images/ContactUs/hero/tablet@2x.jpg';
import Desktop from '../../../../public/static-preauth/images/ContactUs/hero/desktop.jpg';
import Desktop2x from '../../../../public/static-preauth/images/ContactUs/hero/desktop@2x.jpg';

import MobileWebp from '../../../../public/static-preauth/images/ContactUs/hero/mobile.webp';
import Mobile2xWebp from '../../../../public/static-preauth/images/ContactUs/hero/mobile@2x.webp';
import TabletWebp from '../../../../public/static-preauth/images/ContactUs/hero/tablet.webp';
import Tablet2xWebp from '../../../../public/static-preauth/images/ContactUs/hero/tablet@2x.webp';
import DesktopWebp from '../../../../public/static-preauth/images/ContactUs/hero/desktop.webp';
import Desktop2xWebp from '../../../../public/static-preauth/images/ContactUs/hero/desktop@2x.webp';

const HeroImages: ImageType = {
  webp: [
    { url: MobileWebp, maxBreakpoint: (BREAKPOINTS.SCREEN_SM - 1).toString(), url2x: Mobile2xWebp },
    { url: TabletWebp, maxBreakpoint: (BREAKPOINTS.SCREEN_MD - 1).toString(), url2x: Tablet2xWebp },
    { url: DesktopWebp, minBreakpoint: BREAKPOINTS.SCREEN_MD.toString(), url2x: Desktop2xWebp },
  ],
  jpg: [
    { url: Mobile, maxBreakpoint: (BREAKPOINTS.SCREEN_SM - 1).toString(), url2x: Mobile2x },
    { url: Tablet, maxBreakpoint: (BREAKPOINTS.SCREEN_MD - 1).toString(), url2x: Tablet2x },
    { url: Desktop, minBreakpoint: BREAKPOINTS.SCREEN_MD.toString(), url2x: Desktop2x },
  ],
};

const Hero: React.FC = (): JSX.Element => {
  return (
    <HeroSection>
      <MediaContainer>
        <picture>
          {getSourceElements(HeroImages.webp, 'webp', true)}
          {getSourceElements(HeroImages.jpg, 'jpg', true)}
          <HeroImage src={Desktop} alt="" />
        </picture>
      </MediaContainer>
      <ContentWrapper>
        <HighlightTitle>
          We&#8217;re <span>here to help</span>
        </HighlightTitle>
        <ButtonWrapper>
          <ButtonV3 component="a" href="/order-status" size="large" variant="secondary">
            Track your order
          </ButtonV3>
          <ButtonV3 component="a" href="/order-status" size="large">
            Return or replace an item
          </ButtonV3>
        </ButtonWrapper>
      </ContentWrapper>
    </HeroSection>
  );
};

export default Hero;
